import angular from 'angular'
import retrieveService from 'retrieveService'
import routers from './routers.js'
import modalRetrieveCtrl from './modalRetrieveCtrl.js'
import { retrieve } from 'redevConfig'

const list = (retrieve && retrieve.list) || ''
const retrieveCtrl = list ? require(`redevelopment/outputManage/retrieve/${list.controllerName}`) : require('./retrieveCtrl.js')
export default angular
    .module('outputManage.stock.retrieve', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('retrieveCtrl', retrieveCtrl.default)
    .controller('modalRetrieveCtrl', modalRetrieveCtrl)
    .service('retrieveService', retrieveService)
    .filter('ukeyCodeToName', () => function (input, config) {
        if (!config || input === null || input === undefined) {
            return input
        }
        const arr = config.filter((item) => item.ukeyCode == input)
        if (arr.length > 0) {
            return arr[0].ukeyName
        }
        return input
    })
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/retrieve/index.js